import './WP.scss';
import { PageManager } from '@mvps-genesis/core';

export default class WP extends PageManager {

	constructor( pageContext ) {

		super( pageContext );

	}

	onReady() {

		const self = this;

	}

}
